"use strict";
/* tslint:disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gender = exports.RiskGate = exports.ProductSwitchRestrictionType = exports.ThirdPartyKeywords = exports.RiderEligibility = exports.Result = exports.State = exports.ProductType = exports.ProductCode = void 0;
var ProductCode;
(function (ProductCode) {
    ProductCode["HavenTerm"] = "HavenTerm";
    ProductCode["CASTerm"] = "CASTerm";
    ProductCode["CPL100"] = "CPL100";
    ProductCode["MMDirectTerm"] = "MMDirectTerm";
    ProductCode["HavenDI"] = "HavenDI";
})(ProductCode = exports.ProductCode || (exports.ProductCode = {}));
var ProductType;
(function (ProductType) {
    ProductType["Term"] = "Term";
    ProductType["Whole"] = "Whole";
    ProductType["ShortTermDisability"] = "ShortTermDisability";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var State;
(function (State) {
    State["AL"] = "AL";
    State["AK"] = "AK";
    State["AZ"] = "AZ";
    State["AR"] = "AR";
    State["CA"] = "CA";
    State["CO"] = "CO";
    State["CT"] = "CT";
    State["DE"] = "DE";
    State["DC"] = "DC";
    State["FL"] = "FL";
    State["GA"] = "GA";
    State["HI"] = "HI";
    State["ID"] = "ID";
    State["IL"] = "IL";
    State["IN"] = "IN";
    State["IA"] = "IA";
    State["KS"] = "KS";
    State["KY"] = "KY";
    State["LA"] = "LA";
    State["MS"] = "MS";
    State["ME"] = "ME";
    State["MD"] = "MD";
    State["MA"] = "MA";
    State["MI"] = "MI";
    State["MN"] = "MN";
    State["MO"] = "MO";
    State["MT"] = "MT";
    State["NE"] = "NE";
    State["NV"] = "NV";
    State["NH"] = "NH";
    State["NJ"] = "NJ";
    State["NM"] = "NM";
    State["NY"] = "NY";
    State["NC"] = "NC";
    State["ND"] = "ND";
    State["OH"] = "OH";
    State["OK"] = "OK";
    State["OR"] = "OR";
    State["PA"] = "PA";
    State["PR"] = "PR";
    State["RI"] = "RI";
    State["SC"] = "SC";
    State["SD"] = "SD";
    State["TN"] = "TN";
    State["TX"] = "TX";
    State["UT"] = "UT";
    State["VT"] = "VT";
    State["VA"] = "VA";
    State["WA"] = "WA";
    State["WV"] = "WV";
    State["WI"] = "WI";
    State["WY"] = "WY";
})(State = exports.State || (exports.State = {}));
var Result;
(function (Result) {
    Result["Notified"] = "Notified";
})(Result = exports.Result || (exports.Result = {}));
var RiderEligibility;
(function (RiderEligibility) {
    RiderEligibility["Eligible"] = "Eligible";
    RiderEligibility["Ineligible"] = "Ineligible";
    RiderEligibility["Unmodified"] = "Unmodified";
})(RiderEligibility = exports.RiderEligibility || (exports.RiderEligibility = {}));
var ThirdPartyKeywords;
(function (ThirdPartyKeywords) {
    ThirdPartyKeywords["PrescriptionHistory"] = "prescription history";
    ThirdPartyKeywords["Labs"] = "labs";
    ThirdPartyKeywords["ParamExam"] = "paramedical exam";
})(ThirdPartyKeywords = exports.ThirdPartyKeywords || (exports.ThirdPartyKeywords = {}));
var ProductSwitchRestrictionType;
(function (ProductSwitchRestrictionType) {
    ProductSwitchRestrictionType["PayTheDifference"] = "PayTheDifference";
    ProductSwitchRestrictionType["WLWithMaxFaceUnder50K"] = "WLWithMaxFaceUnder50K";
    ProductSwitchRestrictionType["UnderSeventeenAndHalf"] = "UnderSeventeenAndHalf";
})(ProductSwitchRestrictionType = exports.ProductSwitchRestrictionType || (exports.ProductSwitchRestrictionType = {}));
var RiskGate;
(function (RiskGate) {
    RiskGate["Accelerated"] = "Accelerated";
    RiskGate["TLIC"] = "TLIC";
    RiskGate["Algo"] = "Algo";
    RiskGate["Manual"] = "Manual";
    RiskGate["LiteTouch"] = "LiteTouch";
})(RiskGate = exports.RiskGate || (exports.RiskGate = {}));
var Gender;
(function (Gender) {
    Gender["M"] = "M";
    Gender["F"] = "F";
})(Gender = exports.Gender || (exports.Gender = {}));
//# sourceMappingURL=UnderwritingApiTypes.js.map